import React from 'react';
import { Tabs, Tab, Alert, Row, Col, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import DateChoiceEditList from '../dateChoice/DateChoiceEditList';
import InvitedEditList from '../invited/InvitedEditList';
import EventEditDetail from './EventEditDetail';
import { translate } from "react-i18next";
import './EventAddTabs.css';
import { sendJson, getURL, deleteItem, TEMPORARY, DEACTIVATED, ACTIVATED } from '../../backend/Backend';
import {GREEN_LIGHT} from '../../backend/Colors';
import { Redirect } from 'react-router-dom';


function emptyEventDetail() {
  return { title: '', comment: '', commentsEnabled: '', location: '', maxParticipants: '' };
}

/**
 * creator change event
 */
class EventChangePages extends React.Component {
  constructor(props) {
    super(props);
    this.saveEvent = this.saveEvent.bind(this);
    this.deleteEvent = this.deleteEvent.bind(this);
    this.cloneEvent = this.cloneEvent.bind(this);
    this.onRadioInputChange = this.onRadioInputChange.bind(this);
    this.onInvitedUserChange = this.onInvitedUserChange.bind(this);

    this.onInputChange = this.onInputChange.bind(this);
    this.loadDateChoiceResponses = this.loadDateChoiceResponses.bind(this);
    this.updateModel = this.updateModel.bind(this);
    this.updateEventStatus = this.updateEventStatus.bind(this);
    this.onSelectTab = this.onSelectTab.bind(this);
    this.fileChanged = this.fileChanged.bind(this);
    this.removeFile = this.removeFile.bind(this);
    

    this.state = {
      event: {
        eventDetail: emptyEventDetail(),
        dateChoices: [],
        "invitedUsers": [], "newUserName": '', "newUserEmail": '',
        "allDateChoiceResponses": [],
        activePage: 1,
        totalPages: 0

      },
      message: '',
      deleted: false,
      redirectLink: '',
      activeTab:this.props.activeTab ? this.props.activeTab : "edit" 
    }
  }

  updateModel(name, value) {
    console.log("name: " + name +" value: "+value);
    if(name === "eventDetail"){
      let oldState = this.state;
      let oldDetail = this.state.event.eventDetail;
     // oldDetail.title = json.eventDetail.title;
      //oldDetail.description = json.eventDetail.description;
      //oldDetail.eventLink = json.eventDetail.eventLink;
      let newDetail = {
        ...this.state.event.eventDetail,
        title: value.title 
      }
      console.log("newDetail: " + JSON.stringify(newDetail));
      let newEvent = {
        ...this.state.event,
        eventDetail: oldDetail 
      }
 
     
      this.setState({
        ...oldState,
        event: newEvent
      });
    }
  }


  async componentDidMount() {
    console.log("event id" + this.props.id);
    const response = await fetch(getURL(`events/changeevent/` + this.props.id));
    const json = await response.json();
    let oldEvent = this.state.event;
    console.log("json.eventDetail : " + JSON.stringify(json.eventDetail));
    console.log("oldEvent.eventDetail : " + JSON.stringify(oldEvent.eventDetail));

    oldEvent.eventDetail.title = json.eventDetail.title;
    oldEvent.eventDetail.description = json.eventDetail.description;
    oldEvent.eventDetail.eventLink = json.eventDetail.eventLink;
    oldEvent.eventDetail.eventStatus = json.eventDetail.eventStatus;
    oldEvent.eventDetail.eventId = json.eventDetail.eventId;
    oldEvent.eventDetail.maxParticipants = json.eventDetail.maxParticipants;
    oldEvent.eventDetail.commentsEnabled = json.eventDetail.commentsEnabled;
    oldEvent.eventDetail.location = json.eventDetail.location;
    oldEvent.eventDetail.template = json.eventDetail.template;
    oldEvent.eventDetail.eventType = json.eventDetail.eventType;
    oldEvent.eventDetail.eventCategory = json.eventDetail.eventCategory;
    oldEvent.eventDetail.subCategory = json.eventDetail.subCategory;
    oldEvent.eventDetail.imageName = json.eventDetail.imageName;
    //localname, street, zipcode, city
    oldEvent.eventDetail.locationName = json.eventDetail.locationName;
    oldEvent.eventDetail.street = json.eventDetail.street;
    oldEvent.eventDetail.zipcode = json.eventDetail.zipcode;
    oldEvent.eventDetail.city = json.eventDetail.city;
    oldEvent.eventDetail.country = json.eventDetail.country;


    //oldEvent.eventDetail = json.eventDetail; 
    console.log("oldEvent.eventDetail2 : " + JSON.stringify(oldEvent.eventDetail));
    oldEvent.dateChoices = json.dateChoices;
    let oldState = this.state;
    this.setState({ 
      ...oldState,
      event: oldEvent,
      activeTab: this.props.activeTab ? this.props.activeTab : "edit" 
    });
  }




  saveEvent(eventDetail) {
    sendJson('post', 'events/saveDetail', eventDetail).then(
      received => {
        //this.props.onAdd(received);
        console.log("Saved newModel: " + JSON.stringify(received));//+received.eventDetail.name); 
        let oldState = this.state;
        this.setState({
          ...oldState,
          message: 'successSaved'
        });
        setTimeout(() => this.setState({ ...oldState, message: '' }), 1000);
      });

  }

  deleteEvent() {

    deleteItem('events', this.state.event.eventDetail.eventId).then(
      received => {
        if (received.ok) {
          let oldState = this.state;
          this.setState({
            ...oldState,
            message: 'successDeleted',
            deleted: true
          });
          setTimeout(() => this.setState({ ...oldState, message: '' }), 1000);
        }
      });
  }

  async cloneEvent() {
    const response = await fetch(getURL(`events/cloneevent/` + this.state.event.eventDetail.eventId));
    const json = await response.json();

    if (json.data) {
      let oldState = this.state;
      this.setState({
        ...oldState,
        redirectLink: "/eventClone/" + json.data.creatorLink
      });
    }
  }


  onInputChange(obj) {
    const { name: fieldName, value: fieldValue } = obj.target;
    let oldEvent = this.state.event;

    const newEvent = {
      ...oldEvent,
      [fieldName]: fieldValue
    };

    this.setState({
      event: newEvent
    });
  }

  async loadDateChoiceResponses() {
    const response = await fetch(getURL(`loadDateChoiceResponses/` + this.props.id));
    const json = await response.json();
    let oldEvent = this.state.event;
    let newEvent = {
      ...oldEvent,
      allDateChoiceResponses: json
    }
    this.setState({ event: newEvent });
  }

  onInvitedUserChange(value) {
    let oldEvent = this.state.event;
    let invitedUser = this.state.event.invitedUser;
    let newInvitedUser = {
      ...invitedUser,
      responseType: value
    }
    let newEvent = {
      ...oldEvent,
      invitedUser: newInvitedUser
    }

    this.setState({ event: newEvent });
  }

  onRadioInputChange(value, id) {
    let choiceResponseModels = this.state.event.choiceResponseModels;
    let choice = choiceResponseModels.find(e => e.dateChoiceId === id);
    const index = choiceResponseModels.findIndex(i => i.dateChoiceId === id);
    choice.responseType = value;
    let newModels = [...choiceResponseModels.slice(0, index),
      choice,
    ...choiceResponseModels.slice(index + 1)];

    let oldEvent = this.state.event;
    let newEvent = {
      ...oldEvent,
      choiceResponseModels: newModels
    }
    this.setState({ event: newEvent });
  }

  updateEventStatus(eventStatus) {
    let eventDetail = this.state.event.eventDetail;

    const newEventDetail = {
      ...eventDetail,
      eventStatus: eventStatus
    };

    console.log("event limit changed:" + JSON.stringify(newEventDetail));

    let oldEvent = this.state.event;
    const newEvent = {
      ...oldEvent,
      eventDetail: newEventDetail
    }

    let oldState = this.state;

    this.setState({
      ...oldState,
      event: newEvent
    });
    this.saveEvent(newEventDetail);
  }

  onSelectTab(name) {
 
   let oldState = this.state;

    this.setState({
      ...oldState,
      activeTab: name
    });
  }

  fileChanged(file) {
    let oldEvent = this.state.event; 
    oldEvent.eventDetail.file = file;
    let oldState = this.state;
    this.setState({
      ...oldState,
      file: file,
      event: oldEvent
    });
  }

  removeFile() {
    let oldState = this.state;
    this.setState({
      ...oldState,
      file: null
    });
  }



  render() {
    if (this.state.redirectLink) {
      return <Redirect to={this.state.redirectLink} />
    }
    const { t } = this.props;

    

    let finishButton = ( this.state.event.eventDetail.eventStatus === TEMPORARY) ? (<OverlayTrigger
      key="top"
      placement="top"
      overlay={
        <Tooltip id={`tooltip-top`}>
          {t("finish")}
        </Tooltip>
      }>
      <Button variant="outline-primary" onClick={() => this.updateEventStatus(ACTIVATED)} className="float-right mr-2 mt-3"><span className="fa fa-ban ">&nbsp;{t("finish")}</span></Button>
    </OverlayTrigger>) : '';

    let deactivateButton = ( this.state.event.eventDetail.eventStatus !== TEMPORARY && this.state.event.eventDetail.eventStatus !== DEACTIVATED) ? (<OverlayTrigger
      key="top"
      placement="top"
      overlay={
        <Tooltip id={`tooltip-top`}>
          {t("eventDeactivate")}
        </Tooltip>
      }>
      <Button variant="outline-primary" onClick={() => this.updateEventStatus(DEACTIVATED)} className="float-right mr-2 mt-3" disabled={this.state.deleted} ><span className="fa fa-ban ">&nbsp;{t("eventDeactivate")}</span></Button>
    </OverlayTrigger>) : '';

    let activateButton = ( this.state.event.eventDetail.eventStatus === DEACTIVATED) ? (<OverlayTrigger
      key="top"
      placement="top"
      overlay={
        <Tooltip id={`tooltip-top`}>
          {t("eventActivate")}
        </Tooltip>
      }>
      <Button variant="outline-primary" onClick={() => this.updateEventStatus(ACTIVATED)} className="float-right mr-2 mt-3" disabled={this.state.deleted} ><span className="fa fa-ban ">&nbsp;{t("eventActivate")}</span></Button>
    </OverlayTrigger>) : '';


    let activeButtons = (
<div>
   
           <OverlayTrigger
             key="top"
             placement="top"
             overlay={
               <Tooltip id={`tooltip-top`}>
                 {t("eventLoeschen")}
               </Tooltip>
             }>
             <Button variant="outline-primary" onClick={() => this.deleteEvent()} className="float-right mr-2 mt-3" disabled={this.state.deleted}><span className="fa fa-trash ">&nbsp;{t("eventLoeschen")}</span></Button>
           </OverlayTrigger>

         
         </div>

    );

    return (
      <div className=" justify-content-between d-relative  ">
  
        <Tabs defaultActiveKey={this.state.activeTab} id="noanim-tab-event" onSelect={(e) => this.onSelectTab(e)}>
          <Tab eventKey="edit" title={t("erreignis")} className=" pt-2 pl-2  pb-1 "  style={{"background":GREEN_LIGHT}}   onSelect={() => this.onSelectTab('edit')}>
            <EventEditDetail updateModel={this.updateModel.bind(this)} detailModel={this.state.event.eventDetail}
              editMode={true} saveEvent={this.saveEvent}
              deleteEvent={this.deleteEvent} deleted={this.state.deleted}
              cloneEvent={this.cloneEvent} />
          </Tab>
          <Tab eventKey="termin" title={t("wann")} className="pt-2 pl-2  pb-1"  style={{"background":GREEN_LIGHT}} mountOnEnter={true}  onSelect={() => this.onSelectTab('termin')}>
            <DateChoiceEditList eventId={this.state.event.eventDetail.eventId} />
          </Tab>
          <Tab eventKey="teilnehmern" title={t("teilnehmern")} className="pt-2 pl-2  pb-1"  style={{"background":GREEN_LIGHT}} mountOnEnter={true}  onSelect={() => this.onSelectTab('teilnehmern')}>
            <InvitedEditList eventId={this.state.event.eventDetail.eventId} id={this.props.id} />
          </Tab>
        </Tabs>
        {this.state.message ?
          <Alert variant="info">
            {t(this.state.message)}
          </Alert>
          :
          ''
        }

        <Row>
          <Col lg={12} md={12}>
            {finishButton}
            {activeButtons}
            {deactivateButton}
            {activateButton}

          </Col>
        </Row>

      </div>);
  }
}

export default translate("translations")(EventChangePages);
